var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"bc85a33b7a86d4ea0ca896c39a0c754398035f28"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["insiderfinance@insiderfinance"]={id:"bc85a33b7a86d4ea0ca896c39a0c754398035f28"};
      